
import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  CARRIAGE_LIST: 'carriage-carriage'
}

const routes = [
  {
    path: 'carriage/',
    name: ROUTES.CARRIAGE_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['carriage_carriage_list'],
      requiresAuth: true
    },
    component: () => import('./CarriageList.vue')
  }

]

export { routes, ROUTES }
